module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAABQ0lEQVQ4T5WSPyiFYRTGfw8xURYmMtzBJJG6k0WirFjYZDLoKt0sCuv1JzNlchcGGUQpgxVlMVAmZZDBYEAcneu9dfowOMv3vuec3/ec3vOIFGa2BgwDHcA7MAW0AY2S5qt9CkABWK/ew3dCUvk3oA64BdpD8yPQKuntB+AJM8sBrtQCvABlSSdRNY7k50ngEngCmoBOSTt/AbvAaCp+ALXpvC3Jf1SJioKZLQMLKXcDdAFnQA9QAxQllSqAmXUD56lwB+QT+AwcAf3Ap8OSrhzYA0ZSU0lS0cwOgT6gIcx/IanXgVegPhXugSFJ10n5wJ81QHkHLCRc2u/7wBgwC6yGeiELbABbQLOkUzPzJx0PwEwWeEjLmjOzY2AwNLtyzoHNZLS4H9/uQMZXS5IWq3vwWaeTO7P+cz+tSPJxvxf3n/gCQxVxOEE9dGsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/insuredValue.png
// module id = MtW6
// module chunks = 2